import React from "react";
import { ResultCardCalloutProps } from "@usereactify/search";

export type ResultCardCalloutsProps = React.ComponentProps<
    NonNullable<ResultCardCalloutProps["render"]>
> & {
    productsPerRow: string;
};

export const ResultCardCallout: React.FC<ResultCardCalloutsProps> =
    ({
        callout,
        itemRef,
        handleClick,
        productsPerRow
    }) => {

        const styleProp = React.useMemo<React.HTMLAttributes<HTMLElement>["style"]>(
            () => ({
                gridRow: `span ${productsPerRow === "one" ? 1 : callout.displayRows ?? 1}`,
                gridColumn: `span ${productsPerRow === "one" ? 1 : productsPerRow === "three" && callout.displayColumns === '4' ? 3 : productsPerRow === "two" && callout.displayColumns === '4' ? 2 : callout.displayColumns ?? 1}`,
            }),
            [productsPerRow, callout]
        );

        return (
            <div
                className="rs__result-card-callout"
                ref={itemRef}
                style={styleProp}
            >
                <a
                    className="rs__result-card-callout__link"
                    onClick={handleClick}
                    {...(callout.link && { href: callout.link })}
                >
                    {/* Desktop Content */}
                    {callout.desktopImage ? (
                        <img
                            className="rs__result-card-callout__image w-full"
                            src={callout.desktopImage}
                            alt={callout.title || "Image"}
                        />
                    ) : callout.desktopVideo ? (
                        <video
                            className="rs__result-card-callout__video w-full"
                            muted
                            loop
                            autoPlay
                        >
                            <source src={callout.desktopVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    ) : null}

                    {/* Mobile Content */}
                    {callout.mobileImage ? (
                        <img
                            className="rs__result-card-callout__mobile-image w-full"
                            src={callout.mobileImage}
                            alt={callout.title || "Mobile Image"}
                        />
                    ) : callout.mobileVideo ? (
                        <video
                            className="rs__result-card-callout__mobile-video w-full"
                            muted
                            loop
                            autoPlay
                        >
                            <source src={callout.mobileVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    ) : null}
                </a>
            </div>
        );
    };
